import { childRoutes as employeeRecordRoutes } from "../employeeRecord/routes";
import { childRoutes as customerUserRoutes } from "../customerUser/routes";
import { childRoutes as orgStructureRoutes } from "../orgStructure/routes";
import { childRoutes as customerDocumentRoutes } from "../customerDocument/routes";
import { routes as questionnaireConfigRoutes } from "../../questionnaireConfig/routes";
import { childRoutes as workGroupsRoutes } from "../workGroup/routes";
import { childRoutes as customerSraDepartmentsRoutes } from "../customerSraDepartment/routes";
import { routes as customerTeamsRoutes } from "../customerTeam";

import { ADMIN_ROLES } from "../../auth";

import { detailRoutes } from "./detailRoutes";
import { customerSelector } from "./selectors";
import { AppState } from "./model";

const detailRoute = () => ({
    "/:customerId": {
        title: (state: AppState) => customerSelector(state).name || "Customer",
        "/edit": {
            title: "Edit",
        },
        ...detailRoutes,
        ...employeeRecordRoutes((state: AppState) => customerSelector(state).name),
        ...customerUserRoutes((state: AppState) => customerSelector(state).name),
        ...orgStructureRoutes((state: AppState) => customerSelector(state).name),
        ...customerDocumentRoutes((state: AppState) => customerSelector(state).name),
        ...workGroupsRoutes((state: AppState) => customerSelector(state).name),
        ...customerSraDepartmentsRoutes((state: AppState) => customerSelector(state).name),
        ...questionnaireConfigRoutes,
        ...customerTeamsRoutes,
    }
});

export const routes = {
    "/customers": {
        title: "Customers",
        ...detailRoute(),
        authorize: [ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name],
        "/create": {
            title: "Create Customer"
        }
    }
};
